import { Users, Briefcase, Building2 } from "lucide-react";
import { getInsightBySlug } from "@/data/insights";

export const ItStakeholderHeroSection = () => {
  const insight = getInsightBySlug("it-stakeholder-roles");
  
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-background via-background to-muted/30" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[600px] bg-primary/5 rounded-full blur-3xl" />
      <div className="absolute top-20 right-0 w-[400px] h-[400px] bg-indigo-500/5 rounded-full blur-3xl" />
      
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 pt-8 sm:pt-12 pb-8">
        <div className="text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-gradient-to-r from-primary/10 to-indigo-500/10 border border-primary/20 text-primary text-sm font-medium mb-5">
            <Users className="w-4 h-4" />
            {insight?.tag}
          </div>
          
          <h1 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-foreground mb-4">
            <span className="bg-gradient-to-r from-primary via-indigo-500 to-cyan-500 bg-clip-text text-transparent">IT Stakeholder</span>
            {" "}Roles
          </h1>
          <p className="text-lg sm:text-xl text-primary font-medium mb-4">
            {insight?.subtitle}
          </p>
          <p className="text-muted-foreground text-base sm:text-lg max-w-2xl mx-auto leading-relaxed mb-8">
            {insight?.description}
          </p>
          
          <div className="flex flex-wrap justify-center gap-6 sm:gap-10">
            <div className="text-center">
              <div className="flex items-center justify-center gap-2 text-2xl sm:text-3xl font-bold text-foreground">
                <Briefcase className="w-6 h-6 text-primary" />
                6+
              </div>
              <div className="text-xs sm:text-sm text-muted-foreground">key roles explained</div>
            </div>
            <div className="text-center">
              <div className="flex items-center justify-center gap-2 text-2xl sm:text-3xl font-bold text-foreground">
                <Building2 className="w-6 h-6 text-chart-2" />
                RACI
              </div>
              <div className="text-xs sm:text-sm text-muted-foreground">matrix included</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
